import React, { useState } from 'react';
import { Tooltip, Button, Icon } from 'antd';
import { FaFileDownload } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import requestVoiting from './requestVoiting';

const ButtonS = ({ loading, onClick }) => {
  return (
    <Tooltip
      title="Выгрузить результаты"
      placement="top"
    >
      <Button
        type="primary"
        shape="circle"
        icon={loading ? 'loading' : ''}
        style={{ marginRight: '10px', fontSize: '16px' }}
        onClick={onClick}
      >
        {!loading && <Icon component={FaFileDownload} />}
      </Button>
    </Tooltip>
  );
};

const ButtonSave = () => {
  const [loading, setLoading] = useState(false);
  const votingId = useSelector((state) => state.votingStore.voting.id);

  return (
    <ButtonS loading={loading} onClick={() => requestVoiting(setLoading, votingId)}/>
  )
}

export default ButtonSave;